import { render, staticRenderFns } from "./ChangeDeliveryOrders.vue?vue&type=template&id=5a3278c9"
import script from "./ChangeDeliveryOrders.vue?vue&type=script&lang=js"
export * from "./ChangeDeliveryOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports